import { ProductListDiscountSection, ProductListDiscountSlot } from "@lib/dtos/project/product-list-discount.dto";

export interface ProductListDiscountKey {
  section: ProductListDiscountSection;
  ownerId?: string;
  slot: ProductListDiscountSlot;
  productId: string;
}

export function createProductListDiscountKey(key: ProductListDiscountKey): string {
  const ownerId = key.section === ProductListDiscountSection.ATTACHMENT_INSTRUCTIONS ? null : (key.ownerId ?? null);
  return JSON.stringify([key.section, ownerId, key.slot, key.productId]);
}

export function productListDiscountKeysMatch(left: ProductListDiscountKey, right: ProductListDiscountKey): boolean {
  return createProductListDiscountKey(left) === createProductListDiscountKey(right);
}
